import React from 'react';
import { IconProps } from '../../../types/components';

export default function FaxSharpRegular({ iconClass }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      className={`svg-inline--fa ${iconClass || ''}`}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 512 512"
    >
      <path
        fill="currentColor"
        d="M152 0H128V24 128H48 0v48V464v48H48 96h32 48H488h24V488 216 192H488 176V176 128 48H390.1L432 89.9V160h48V80 70.1l-7-7L417 7l-7-7H400 152zm24 240H464V464H176V240zM128 464H96 48V176h80v40 24V464zM304 272H240v64h64V272zm-64 96v64h64V368H240zm160-96H336v64h64V272zm-64 96v64h64V368H336z"
      />
    </svg>
  );
}
